<template>
  <div class="unconnect-page">
      <title-component v-if="getActiveWalks.length === 0">
          Er zijn op dit moment geen actieve smartwatches
      </title-component>
      <table v-if="getActiveWalks.length > 0">
          <thead>
            <tr>
                <th v-for="col in tableColumns" :key="col" class="table-head">{{ col }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="walk in getActiveWalks" :key="walk.id" class="table-row" @click="onSelect(walk)">
                <td>{{ walk.smartwatch.smartwatchName }}</td>
                <td>{{ walk.client.initials }}</td>
                <td>{{ walk.walkSettings.endTime | toSimpleDateFormat }}</td>
            </tr>
          </tbody>
      </table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { Walk } from "../domain/walk";
  import { RouteName } from '../utils/enums';

export default {
  name: 'smartwatch-overview-page',
  computed: {
    ...mapGetters(['getActiveWalks']),
  },
  data: function () {
    return {
      tableColumns: ['Smartwatch', 'Client', 'Terugkeertijd']
    }
  },
  created() {
    this.$store.dispatch("FETCH_ACTIVE_WALKS");
  },
    methods: {
        onSelect(walk) {
            this.$store.commit('SET_ACTIVE_WALK', walk);
            this.$router.push({ name: RouteName.ACTIVE_SMARTWATCH_SETTINGS });
        }
    }
};
</script>
<style scoped lang="scss">
  table {
    width: 100%;
      background-color: $white;
  }

  .table-head {
    background-color: $primary;
    color: $white;
  }

  th, td {
    text-align: left;
    padding: 8px;
  }

  tr {
    border-radius: 0.25rem;
    height: 4rem;
    box-shadow: 0 -2px 8px 0px rgba(0, 0, 0, 0.1);
    margin-bottom: 1rem;
    overflow: hidden;
    transition: 0.3s ease all;
  }

  tr:hover td {
    background-color: $gray;
    cursor: pointer;
  }
</style>
